import * as React from 'react';
import TextField from '@sdk/components/forms/TextField';
import DisplayText from '@sdk/components/ui/DisplayText';
import Column from '@sdk/components/ui/spacing/Column';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import type { GeoAddress } from './GeoAddressField/geoAddressField.types';
import type { LocationsFormType } from './types/LocationsForm';
import GeoAddressField from './GeoAddressField/GeoAddressField';

type Props = { location: LocationsFormType };

const LocationRow: React.FC<React.PropsWithChildren<Props>> = ({ location }) => {
  const { address, coordinates } = location;

  const onChangeHandler = (value: GeoAddress) => {
    address.onChange(value.address);
    if ('coordinates' in value) {
      coordinates.onChange(value.coordinates);
    }
  };

  return (
    <>
      <Column>
        <DisplayText pBottom={5} fontSize={11} bold themeColor={ThemeColorType.gray} uppercase>
          {gettext('Location name')}
        </DisplayText>
        <TextField readOnly skipErrorMessage value={location.name.value} />
      </Column>

      <Column pBottom={20}>
        <DisplayText
          pTop={20}
          pBottom={5}
          fontSize={11}
          bold
          themeColor={ThemeColorType.gray}
          uppercase>
          {gettext('Address')}
        </DisplayText>
        <GeoAddressField onChange={onChangeHandler} value={address.value} />
      </Column>
    </>
  );
};

export default LocationRow;
